module.exports = {"guoyin":{"logo":"","myExamList":{"tab1":"1.材料提交","tab2":"2.缴费与通知单下载","goBtu":"开始填报","time":"填报时间","subjectNameTxt":"报考院系","signPage":true,"canPay":true},"problem":{"uploadBtu120":"上传材料","allowHook":{"doc":"application/pdf,.docx","video":".mp4","audio":".wav"}}},"Dr":{"logo":"","myExamList":{"tab1":"1.材料提交","tab2":"2.已完成","goBtu":"开始填报","time":"填报时间","subjectNameTxt":"报考专业","signPage":false,"canPay":false},"problem":{"uploadBtu120":"上传材料","allowHook":{"doc":"application/pdf","img":".jpg","video":".mp4","audio":".wav"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/veinQuest.json
// module id = 7dpI
// module chunks = 1